import dayjs from 'dayjs';
import 'dayjs/locale/pl';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc as typeof utc);

export function toDasApiFormat(date: Date): string {
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
}
